// client/src/components/HomeClient.js

import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import HomeFooter from "./HomeFooter";
import HomeHeader from "./HomeHeader";
import { HomeStyles, StepLine, FeatureCard } from "./HomeUI";

export default function HomeClient() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 900);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 900);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const banner =
    "https://firebasestorage.googleapis.com/v0/b/ecobill-pay.firebasestorage.app/o/Administratif%2Fbanniere_home_utilisateurs.png?alt=media&token=52c23d85-54aa-491b-a017-18516cb7bf63";

  const features = useMemo(
    () => [
      {
        emoji: "📱",
        title: "Récupérez vos fidélités",
        reverse: false,
        content: (
          <>
            <ul className="lp-checks">
              <StepLine>Scannez les QR-Codes Ecobill à vos passages en caisse</StepLine>
              <StepLine>Obtenez un code unique, et donnez-le en caisse</StepLine>
              <StepLine>Votre passage est comptabilisé automatiquement</StepLine>
              <StepLine>Après le nombre requis, vous recevez votre gain</StepLine>
            </ul>
          </>
        ),
      },
      {
        emoji: "💬",
        title: "Donnez votre avis",
        reverse: true,
        content: (
          <>
            <p className="lp-text" style={{ marginBottom: 14 }}>
              Après le scan, laissez une note simple pour aider l’enseigne à s’améliorer.
            </p>
            <ul className="lp-checks">
              <StepLine>Scannez le QR-Code à votre passage</StepLine>
              <StepLine>Notez l’entreprise de 1 à 5 étoiles</StepLine>
            </ul>
          </>
        ),
      },
      {
        emoji: "🎁",
        title: "Consultez les promotions",
        reverse: false,
        content: (
          <>
            <p className="lp-text" style={{ marginBottom: 14 }}>
              Retrouvez rapidement les offres de nos partenaires depuis votre compte.
            </p>
            <ul className="lp-checks">
              <StepLine>Allez dans la section Promotions</StepLine>
              <StepLine>Consultez les offres disponibles</StepLine>
            </ul>
          </>
        ),
      },
      {
        emoji: "🧾",
        title: "Regroupez vos factures",
        reverse: true,
        content: (
          <>
            <ul className="lp-checks">
              <StepLine>Prenez votre facture en photo</StepLine>
              <StepLine>Validez pour l’enregistrer dans votre espace</StepLine>
            </ul>

            <div className="lp-note" style={{ marginTop: 16 }}>
              Votre compte est associé à une entreprise ?<br />
              Cochez “Pro” sur la facture pour la partager avec votre direction en temps réel.
            </div>
          </>
        ),
      },
    ],
    []
  );

  return (
    <div className={`lp-page${isMobile ? " is-mobile" : ""}`}>
      <HomeStyles />
      <HomeHeader />

      <header className="lp-hero">
        <div className="lp-shell">
          <div className="lp-hero__grid">
            <div>
              <span className="lp-eyebrow">
                <span className="lp-eyebrow__dot" aria-hidden="true" />
                Ecobill — côté utilisateurs
              </span>

              <h1 className="lp-h1">Gagnez des récompenses en 1 scan</h1>

              <p className="lp-lead">
                Scannez, cumulez, notez et retrouvez vos factures — dans une app simple.
              </p>

              <div className="lp-actions">
                <Link to="/signup" className="lp-btn lp-btn--primary">
                  Créer mon compte <span className="lp-btn__arrow" aria-hidden="true">→</span>
                </Link>
              </div>
            </div>

            <div className="lp-media">
              <img src={banner} alt="Bannière utilisateurs" />
            </div>
          </div>

        </div>
      </header>

      <main className="lp-main">
        <div className="lp-shell">
          <section className="lp-section">
            <div className="lp-grid">
              {features.map((f, i) => (
                <FeatureCard key={i} emoji={f.emoji} title={f.title}>
                  {f.content}
                </FeatureCard>
              ))}
            </div>
          </section>
        </div>
      </main>

      <HomeFooter />
    </div>
  );
}
